import { ConnectionStatus as P2PConnectionStatus } from "@src/services/PeerCommunicator/types";
export const initialRoomUISettings = {
    showInviteModal: false,
    p2pConnectionStatus: P2PConnectionStatus.NOT_CONNECTED,
};
